import { AbstractComponentDemoExamples } from "./AbstractComponentDemoExamples";

export class DemoTabsetExamples extends AbstractComponentDemoExamples {
    protected override registerExamples() {
        super.registerExamples();
        this.registerLiveDemos({
            name: "Styles/Alignments",
            description: "View a sample tabset with any combination of style & alignment",
            layoutPath: "component-demo/components/examples/TabsetLiveDemoStyleAlignment"
        });
    }
}
